var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	45447: () => (loadSingletonVersion("default", "react", false, [,[-1,19],[0,17,0,1],2], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	31245: () => (loadSingletonVersion("default", "react", false, [0,16,8,0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	6422: () => (loadSingletonVersion("stencil@4", "@amzn/stencil-react-utils", false, [1,4,0,0], () => (__webpack_require__.e(231).then(() => (() => (__webpack_require__(42612))))))),
	5291: () => (loadSingletonVersion("default", "react", false, [0,16,8], () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))))),
	10202: () => (loadSingletonVersion("stencil@4", "@amzn/stencil-react-icons", false, [1,4,0,0], () => (__webpack_require__.e(7157).then(() => (() => (__webpack_require__(99538))))))),
	21482: () => (loadSingletonVersion("default", "react", false, [0,16,12,0], () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))))),
	25884: () => (loadSingletonVersion("default", "react-dom", false, [0,16,13,1], () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(1502)]).then(() => (() => (__webpack_require__(40961))))))),
	49811: () => (loadSingletonVersion("default", "react", false, [0,0,14,0], () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))))),
	55931: () => (loadSingleton("default", "react", false, () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))))),
	56708: () => (loadSingletonVersion("default", "react", false, [,[1,19],[-1,19],1,[0,16],2], () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))))),
	58594: () => (loadSingletonVersion("stencil@4", "@amzn/stencil-react-desc", false, [1,4,0,0], () => (__webpack_require__.e(1149).then(() => (() => (__webpack_require__(93530))))))),
	60249: () => (loadSingletonVersion("default", "react-dom", false, [,[1,18,0,0],[1,17,0,0],[1,16,8,0],1,1], () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(1502)]).then(() => (() => (__webpack_require__(40961))))))),
	66339: () => (loadSingletonVersion("default", "react", false, [2,17,0,2], () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))))),
	81783: () => (loadSingletonVersion("default", "react", false, [,[1,18,0,0],[1,17,0,0],[1,16,8,0],1,1], () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))))),
	89926: () => (loadSingletonVersion("default", "react", false, [0,16,13,1], () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))))),
	97555: () => (loadSingletonVersion("default", "react-dom", false, [,[-1,19],[0,17,0,1],2], () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(1502)]).then(() => (() => (__webpack_require__(40961))))))),
	12605: () => (loadSingletonVersion("default", "react-dom", false, [2,17,0,2], () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(1502)]).then(() => (() => (__webpack_require__(40961))))))),
	60070: () => (loadSingletonVersion("stencil@4", "@amzn/stencil-react-theme-default", false, [1,4,0,0], () => (__webpack_require__.e(5690).then(() => (() => (__webpack_require__(95690))))))),
	69257: () => (loadSingletonVersion("default", "react-router-dom", false, [1,5,3,0], () => (Promise.all([__webpack_require__.e(876), __webpack_require__.e(668)]).then(() => (() => (__webpack_require__(30876))))))),
	1502: () => (loadSingletonVersion("default", "react", false, [4,17,0,2], () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(96540))))))),
	30668: () => (loadSingletonVersion("default", "react", false, [0,15], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	44651: () => (loadSingletonVersion("default", "single-spa-react", false, [1,5,0,0], () => (__webpack_require__.e(5684).then(() => (() => (__webpack_require__(5684))))))),
	28437: () => (loadSingletonVersion("default", "react", false, [0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"28": [
		5291,
		10202,
		21482,
		25884,
		49811,
		55931,
		56708,
		58594,
		60249,
		66339,
		81783,
		89926,
		97555
	],
	"70": [
		60070
	],
	"668": [
		30668
	],
	"1228": [
		60070,
		69257
	],
	"1502": [
		1502
	],
	"2106": [
		31245,
		6422
	],
	"2605": [
		12605
	],
	"4651": [
		44651
	],
	"5447": [
		45447
	],
	"8848": [
		28437
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}